import React from 'react';
import {Button} from 'primereact/button';

import logo from '../static/logo.png';
import Api from '../utils/Api';
import {toggleMenu} from '../utils/utils.js';


class NavBar extends React.Component {

  constructor(props) {
    super(props);
    this.Api = new Api();
    this.handleLogout = this.handleLogout.bind(this);
  }


  handleLogout(event) {
    this.Api.auth.logout()
      .then((res) => {
        this.props.onLogout();
      },function(error){
        console.log(error)
      });
  }



  render() {

    // little subcomponent for the nav menu items
    const NavMenu = (props) => {
      if (props.condition === true) {
        return (
          <a href={props.href} onClick={props.onClick} style={{cursor:'pointer'}}> {props.title} </a>
        )
      } else {
        return null;
      }
    };

    return (
      <div className="layout-topbar grid grid-nogutter">
        <div className="col-fixed" >
          <a href='/#/'><img className='logo' alt='' src={logo} /></a>
        </div>
        <div className="col topbar-menu">

          <div className='topnav' id='topNav'>
            <Button className="hamburger"
                    icon="pi pi-bars"
                    onClick={toggleMenu}/>

            <NavMenu onClick={this.handleLogout} title='Logout' condition={this.props.parentState.loggedIn} />
            <NavMenu href='#/login' title='Login' condition={!this.props.parentState.loggedIn} />
            <NavMenu href='#/mqtt-log' title='MQTT Log' condition={this.props.parentState.isAdmin} />
            <NavMenu href='#/sigfox-log' title='SigFox Log' condition={this.props.parentState.isAdmin} />
            <NavMenu href='#/sms-log' title='SMS Log' condition={this.props.parentState.isAdmin} />
            <NavMenu href='#/deliverers' title='Livreurs' condition={this.props.parentState.isAdmin} /> />
            <NavMenu href='#/services' title='Maintenance' condition={this.props.parentState.isAdmin} />
            <NavMenu href='#/companies' title='Entreprises' condition={this.props.parentState.isAdmin} />
            <NavMenu href='#/page1' title='Livraisons' condition={this.props.parentState.loggedIn} />
          </div>
        </div>
      </div>
    )
  }
}

export default NavBar;
